import { keyframes } from 'styled-components';

export const TrackingInExpand = keyframes`
  0% {
    opacity: 0;
    letter-spacing: -.5rem;
  }
  40% {
    opacity: .6;
  }
  100% {
    opacity: 1;
  }
`;
